@if (open()) {
  <button
    class="notification-panel__backdrop"
    type="button"
    aria-label="Cerrar panel de notificaciones"
    (click)="onClose()"
  ></button>

  <aside class="notification-panel" role="dialog" aria-modal="true" aria-label="Notificaciones">
    <header class="notification-panel__header">
      <div class="notification-panel__title-wrap">
        <h2 class="notification-panel__title">Notificaciones</h2>
        <span class="notification-panel__meta">{{ unreadCount() }} sin leer</span>
      </div>
      <button
        class="notification-panel__close"
        type="button"
        aria-label="Cerrar notificaciones"
        (click)="onClose()"
      >
        <i class="pi pi-times"></i>
      </button>
    </header>

    <section class="notification-panel__content" (scroll)="onScroll($event)">
      @if (state() === 'loading') {
        <div class="notification-panel__state">
          <i class="pi pi-spin pi-spinner"></i>
          <p>Cargando notificaciones…</p>
        </div>
      } @else if (state() === 'error') {
        <div class="notification-panel__state">
          <i class="pi pi-exclamation-triangle"></i>
          <p>{{ errorMessage() ?? 'Ocurrio un error al cargar notificaciones.' }}</p>
          <button class="notification-panel__retry" type="button" (click)="onRetry()">
            Reintentar
          </button>
        </div>
      } @else if (state() === 'empty') {
        <div class="notification-panel__state">
          <i class="pi pi-inbox"></i>
          <p>No hay notificaciones.</p>
        </div>
      } @else {
        <div class="notification-panel__list">
          @for (notification of notifications(); track notification.id) {
            <app-notification-item
              [item]="notification"
              (open)="onSelect($event)"
            />
          }
        </div>

        @if (loadingMore()) {
          <div class="notification-panel__more">
            <i class="pi pi-spin pi-spinner"></i>
            <span>Cargando más notificaciones…</span>
          </div>
        }
      }
    </section>
  </aside>
}

